import { Check, Ban } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useVault } from "@/context/VaultContext";
import { preview } from "@/lib/selectors";
import { Avatar } from "@/components/Loader";

export function RequestsDialog({ open, onOpenChange, requests }) {
  const { profile, acceptRequest, blockRequest, setActiveSid } = useVault();
  const accept = async (sid) => {
    await acceptRequest(sid);
    onOpenChange(false);
    setActiveSid(sid);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="requests-dialog" className="bg-nebula border-rim text-ash sm:max-w-md rounded-secure">
        <DialogHeader>
          <DialogTitle className="font-branding">Contact requests</DialogTitle>
          <DialogDescription className="text-ash/50">Unknown IDs can't see whether you're online or have read anything until you accept.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 max-h-80 overflow-y-auto">
          {requests.length === 0 && <p className="text-sm text-ash/45 text-center py-6" data-testid="requests-empty">No pending requests.</p>}
          {requests.map((r) => (
            <div key={r.session_id} className="flex items-center gap-3 bg-void border border-glass rounded-secure p-3" data-testid={`request-item-${r.session_id}`}>
              <Avatar name={r.name} group={r.kind === "group"} />
              <div className="flex-1 min-w-0">
                <p className="font-branding text-sm font-semibold uppercase tracking-wider truncate">{r.name}{r.kind === "group" && <span className="ml-2 text-[10px] text-ash/40 normal-case">group invite</span>}</p>
                <p className="text-xs text-ash/45 truncate">{r.last ? preview(r.last, profile.code) : "Wants to connect"}</p>
              </div>
              <button onClick={() => accept(r.session_id)} data-testid={`request-accept-${r.session_id}`} title="Accept" className="p-2 rounded-secure border border-stellar/40 text-stellar hover:shadow-stellar-glow"><Check size={16} strokeWidth={1.5} /></button>
              <button onClick={() => blockRequest(r.session_id)} data-testid={`request-block-${r.session_id}`} title={r.kind === "group" ? "Decline" : "Block"} className="p-2 rounded-secure border border-flare/40 text-flare hover:bg-flare/10"><Ban size={16} strokeWidth={1.5} /></button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
